import React, { useState, useEffect, useContext } from "react";
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios'
import swal from "sweetalert2";
import { useForm } from "react-hook-form";
import CheckBoxCompany from './Comp/CheckBoxCompany'
import {IsAuthContext} from 'app/App';
import { useHistory } from "react-router-dom";

const useLoad = (modalEditId,setValue,percentageExceptionProfilId)=>{
    const t = useTranslate();
    const [loading,setLoading]=useState(false)
    const [promoOne,setPromoOne]=useState({})
    const [disabled,setDisabled]=useState(false)

    const [check,setCheck] = useState({
        exclude_article:false
    })

    //En cas d'édition, on récupère les infos de la promo concerné pour les attribuer aux champs 
    useEffect(function () {
        (async function() {
            if(modalEditId || percentageExceptionProfilId){
                let idPercentageException = (modalEditId) ? modalEditId : percentageExceptionProfilId
                setLoading(true)
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/exception_percentage/"+idPercentageException
                ).then((response) => {
                    setPromoOne(response.data.data)
                    setValue('name',response.data.data.name)
                    setValue('poids',response.data.data.poids)
                    setValue('value',response.data.data.value??0)
                    setValue('value_fixe',response.data.data.value_fixe??0)

                    setCheck({...check,exclude_article:response.data.data.exclude_article})

                    setDisabled(true)
                    setLoading(false)
                }).catch((error) => {
                    if(error=='end_session') return;
                    let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                    swal.fire(t(errorName), "", "error");
                    setLoading(false)
                })
            }else {
                setValue('value',0)
                setValue('value_fixe',0)
            }
        })()
    }, [])
    return [loading,promoOne,disabled,setDisabled,check,setCheck]
}

const CreatePercentageExceptionForm = (props) =>{
    const t = useTranslate();
    const { register, formState: { errors }, handleSubmit, setValue, reset} = useForm();
    const [loading,promoOne,disabled,setDisabled,check,setCheck]=useLoad(props.modalEditId,setValue,props.percentageExceptionProfilId)
    const [validButton,setValidButton] = useState(false)
    const [apiError,setApiError] = useState(false)
    const [selectedCompany,setSelectedCompany] = useState([])
    const history = useHistory();
        
    let editPromo = props.from=='profilPercentageException' ? props.exceptions.id : props.exceptions.find(value=>value.id==props.modalEditId)

    if(props.modalEditId){
        //On détermine l'index à éditer sur la modal edit 
        let refPromo = props.exceptions.map(value=>value.id)
        var indexToEdit = refPromo.indexOf(editPromo.id)
    }

    const handleChangeCheck = (name) => {
        if(name=='exclude_article'){
            setCheck({
                ...check,
                exclude_article:!check.exclude_article
            })
        }
    };

    const onSubmit = async (data) => {
        let idPercentageException = (props.modalEditId) ? props.modalEditId : props.percentageExceptionProfilId
        setValidButton(true)
        setApiError(false)
        
        let companyPost = (Array.isArray(data.other_company) && data.other_company.includes(props.company.id+'-company')) ? props.company.id : data.other_company == props.company.id+'-company' ? props.company.id : null
        
        let otherCompanyPost 

        if(Array.isArray(data.other_company) && data.other_company.includes(props.company.id+'-company')){
            //Si data.other_company est un array et que ce [] inclut l'id de la company
            //on retourne un [] sans l'id de la company
            otherCompanyPost = data.other_company.filter(value=>value!=props.company.id+'-company')

        }else if(Array.isArray(data.other_company) && !data.other_company.includes(props.company.id+'-company')){
            //Si data.other_company n'inclut pas l'id de la company
            otherCompanyPost = data.other_company

        }else if(!Array.isArray(data.other_company) && data.other_company!=props.company.id+'-company' && data.other_company!=false){
            //Si une seule other company et que ce n'est pas la company
            otherCompanyPost = [data.other_company]

        }else if((!Array.isArray(data.other_company) && data.other_company==props.company.id+'-company') || data.other_company==false){
            //Si la company a été choisi ou que aucune other company ni la company n'a été choisi
            otherCompanyPost = []
        }

        let obj={
            name: data.name,
            poids:data.poids,
            company: companyPost,
            other_company: otherCompanyPost,
            value: data.value,
            value_fixe: data.value_fixe,
            exclude_article:check.exclude_article,
        }

        if(props.modalEditId || props.percentageExceptionProfilId){//Edition d'une promotion
            const response  = await axios.put(process.env.REACT_APP_API_URL+"api/erp/exception_percentage/edit/"+idPercentageException,obj
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach((interm)=>{
                        let finalMessage=interm.split('/!');
                        if(finalMessage.length==2){
                            messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                        }
                        else{
                            messageError+=t(interm)+'<br/>'
                        }
                    })
                    messageError=messageError.replace('undefined','');
                    setApiError(messageError)
                }
                else{
                    props.closeModal()
                    if(props.from=='profilPercentageException'){
                        props.setExceptions(response.data.data)
                    }else{
                        let newData = props.exceptions.filter(value=>value.id!=props.modalEditId)
                        newData.splice(indexToEdit,0, response.data.data)
                        props.setExceptions(newData)
                    }
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })

        }else{//Création d'une promotion
            const response  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/exception_percentage/create",obj
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach((interm)=>{
                        let finalMessage=interm.split('/!');
                        if(finalMessage.length==2){
                            messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                        }
                        else{
                            messageError+=t(interm)+'<br/>'
                        }
                    })
                        messageError=messageError.replace('undefined','');
                        setApiError(messageError)
                }
                else{
                    history.push("/invoice/exception_refacturation/detail/"+response.data.data.id)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })
        }
        setValidButton(false)
        setDisabled(false)
    }

    return(
        <>
            {loading ? 
                <span className="d-flex justify-content-center"><div className="spinner-border spinner-border-sm"></div></span>
            :
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                        <label htmlFor="nomcategorie">{t('labelName')+'* :'}</label>
                        <input id="promotion name"  className="form-control" type="text" {...register('name', {required: true})}/>
                        {errors.name?.type === 'required' && (  
                        <div className="text-danger mt-1 ml-2">
                            {t('nameRequired')}
                        </div>
                        )}
                    </div>
                    <div className="form-group">
                        <label htmlFor="nomcategorie">{t('percentageExceptionWeight')+' :'}</label>
                        <input placeholder={t('valueBetween')+' (1 - 100)'} className="form-control" type="number" {...register('poids', {min:1,max:100})}/>
                        {errors.poids?.type === 'min' && (
                        <div className="text-danger mt-1 ml-2">
                            {t('poidsMin1')}
                        </div>
                        )}
                        {errors.poids?.type === 'max' && (
                        <div className="text-danger mt-1 ml-2">
                            {t('poidsMax100')}
                        </div>
                        )}
                    </div>
                    <div className="form-group row">
                        <label htmlFor="email">{t('company')}</label>
                        <div className="col-3">
                            <CheckBoxCompany otherCompany={props.company} register={register} promoOne={promoOne} modalEditId={editPromo} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} reset={reset} isCompany="true"/>
                        </div>
                        {(Object.keys(props.company).length!=0 && props.company.other_company.length!=0) && props.company.other_company.map((otherCompany)=>
                            <div key={otherCompany.id} className="col-3">
                                <CheckBoxCompany otherCompany={otherCompany} register={register} promoOne={promoOne} modalEditId={editPromo} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} reset={reset} isCompany="false"/>
                            </div>
                        )}
                    </div>
                    <div className="form-group">
                        <div>
                            <div className="form-check">
                                <input id="exclude" checked={check.exclude_article} type="checkbox" className="form-check-input" onChange={() => handleChangeCheck('exclude_article')}/>
                                <label title="" htmlFor="exclude" className="form-check-label">{t('itemsFromPercentageExceptionWillBeExcluded')}</label>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="description">{t('percentageException')+' :'}</label>
                        <div className="input-group">
                            <input  className='form-control mb-2' type="text" aria-describedby="basic-addon1" {...register('value', {required: true})} />
                        </div>
                        {errors.value?.type === 'required' && (
                        <div className="text-danger mt-1 ml-2">
                            {t('fieldRequired')}
                        </div>
                        )}
                    </div>
                    <div className="form-group">
                        <label htmlFor="description">{t('percentageExceptionFixe')+' :'}</label>
                        <div className="input-group">
                            <input  className='form-control mb-2' type="text" aria-describedby="basic-addon1" {...register('value_fixe', {required: true})} />
                        </div>
                        {errors.value?.type === 'required' && (
                        <div className="text-danger mt-1 ml-2">
                            {t('fieldRequired')}
                        </div>
                        )}
                    </div>
                    {(apiError) ? <div className="alert alert-danger mt-3" dangerouslySetInnerHTML={{ __html: apiError }}></div> : false}
                    <button disabled={validButton} className="btn btn-primary mt-3">
                        {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                    </button>
                </form>
            }
        </>
    )
}

export default CreatePercentageExceptionForm;